var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#99AEBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 21.375C33.2543 23.0248 32.8688 24.6523 32.125 26.125C31.243 27.8897 29.8872 29.3739 28.2093 30.4116C26.5314 31.4492 24.5978 31.9992 22.625 32C20.9752 32.0043 19.3476 31.6188 17.875 30.875L10.75 33.25L13.125 26.125C12.3812 24.6523 11.9957 23.0248 12 21.375C12.0008 19.4022 12.5508 17.4685 13.5884 15.7907C14.626 14.1128 16.1103 12.7569 17.875 11.875C19.3476 11.1311 20.9752 10.7457 22.625 10.75H23.25C25.8554 10.8937 28.3163 11.9934 30.1614 13.8385C32.0065 15.6837 33.1063 18.1445 33.25 20.75V21.375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.b717821d5414c27e7662b84b76a7f435.svg";
export { ForwardRef as ReactComponent };